module.exports = __webpack_public_path__ + "img/diesel-locomotive-mask-04.87bc1d0f.png";